import * as React from "react";

import { logger } from "@origin-digital/reporting-client";

import { ICategory } from "../../../../shared/interface/category";
import { routes } from "../../helpers/router.helper";
import { useAppContext } from "../../AppContext";
import { IQuickLink, QuickLink } from "./QuickLink";
import { categoryIcon, sortLinksByOrder } from "./helper";
import { QuickLinkStyles } from "./QuickLink.styles";

export const QuickLinksController = () => {
  const { categories } = useAppContext();
  const links =
    (categories?.data?.categories?.map((category: ICategory) => ({
      title: category.name,
      icon: categoryIcon(category),
      link: routes.category(category.uri),
      order: category.order,
      uri: category.uri,
    })) as IQuickLink[]) || [];

  sortLinksByOrder(links);

  if (!categories?.data?.categories.length) {
    logger.error(
      `QuickLinksController: Did not retrieve categories from Intercom`
    );
    return null;
  }
  return (
    <QuickLinkStyles data-id="quicklinks">
      {links.map((quickLink, index) => (
        <QuickLink {...quickLink} key={`quicklink-${index}`} />
      ))}
    </QuickLinkStyles>
  );
};
